module.exports = __webpack_public_path__ + "static/media/Engpic1@2x.9274312c.png";